import React, { useState, useEffect } from "react";
import { Box, Typography, IconButton, useTheme, Fade } from "@mui/material";
import { styled } from "@mui/system";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle, faTimes } from "@fortawesome/free-solid-svg-icons";

// Zenzero Color Palette
const zenzeroColors = {
  background: "#FFFAE5", // Light background for the banner
  text: "#333", // Text color for readability
  infoIcon: "#FF8300", // Info icon color matching primary Zenzero color
  closeIcon: "#FF4700", // Close icon color matching secondary Zenzero color
  shadow: "rgba(0, 0, 0, 0.2)", // Shadow color
};

// Styled container with updated colors
const BannerContainer = styled(Box)(({ theme = {} }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  backgroundColor: zenzeroColors.background, // Updated background color
  color: zenzeroColors.text, // Updated text color
  padding: "16px",
  margin: "20px",
  borderRadius: "4px",
  boxShadow: theme.shadows
    ? theme.shadows[2]
    : `0px 1px 3px ${zenzeroColors.shadow}`, // Fallback box shadow
  marginBottom: "16px",
}));

const BannerMessage = styled(Typography)({
  flexGrow: 1,
  marginLeft: "16px", // Add some space between the icon and text
  whiteSpace: "pre-line",
});

function InfoBanner({ message, localStorageKey }) {
  const [isDismissed, setIsDismissed] = useState(false);
  const [loading, setLoading] = useState(true); // New loading state
  const theme = useTheme()
  const zenzeroColors = {
    background: theme.palette.success.main, // Light background for the banner
    text: "#333", // Text color for readability
    infoIcon: "#FF8300", // Info icon color matching primary Zenzero color
    closeIcon: "#FF4700", // Close icon color matching secondary Zenzero color
    shadow: "rgba(0, 0, 0, 0.2)", // Shadow color
  };
  
  useEffect(() => {
    // Simulate localStorage check
    const dismissed = localStorage.getItem(localStorageKey);
    if (dismissed === "true") {
      setIsDismissed(true);
    }
    setLoading(false); // Set loading to false after check
  }, [localStorageKey]);

  const handleClose = () => {
    setIsDismissed(true);
    localStorage.setItem(localStorageKey, "true");
  };

  // Return null while loading
  if (loading) {
    return null;
  }

  // Return null if banner is dismissed
  if (isDismissed) {
    return null;
  }

  return (
    <Fade in ={!loading} timeout={2000} >
    <BannerContainer style={{borderStyle:"solid", borderWidth:"1", borderColor: theme.palette.primary.main, backgroundColor: theme.palette.success.main}}>
      {/* FontAwesome Information Icon */}
      <FontAwesomeIcon
        icon={faInfoCircle}
        size="lg"
        style={{ color: theme.palette.success.text }}
      />
      <BannerMessage style={{ fontWeight: "bolder", color: theme.palette.success.text }} variant="body1">{message}</BannerMessage>
      <IconButton onClick={handleClose} size="large">
        {/* FontAwesome Close Icon */}
        <FontAwesomeIcon
          icon={faTimes}
          style={{ color: zenzeroColors.infoIcon }}
        />
      </IconButton>
    </BannerContainer>
    </Fade>
  );
}

export default InfoBanner;
